import { UserDetails } from "@cofano/coastguard2-frontend-client";
import { Box, Typography } from "@mui/material";

const CoastguardUserDetails = ({ userDetails, useSecondaryColors = false }: {
	userDetails: Pick<UserDetails, "displayName" | "username" | "tenantName">;
	useSecondaryColors?: boolean;
}) => (
	<Box sx={{ minWidth: 0, overflow: "hidden" }}>
		<Typography
			variant="body2"
			fontWeight="bold"
			title={userDetails.displayName}
			noWrap
		>
			{userDetails.displayName}
		</Typography>

		<Typography
			variant="body2"
			title={userDetails.username}
			color={useSecondaryColors ? "text.secondary" : undefined}
			noWrap
		>
			{userDetails.username}
		</Typography>

		<Typography
			variant="body2"
			color={useSecondaryColors ? "text.secondary" : undefined}
			title={userDetails.tenantName}
			noWrap
		>
			{userDetails.tenantName}
		</Typography>
	</Box>
);

export default CoastguardUserDetails;
